import React, { useEffect, useMemo } from 'react';
import Chart from 'react-apexcharts';
import { useStudent } from '../../DataStore/StudentContext';

const StudentPopulationGraph = () => {
  const { studentPopulation, getStudentPopulation } = useStudent();

  useEffect(() => {
    getStudentPopulation();
  }, []);

  const chartData = useMemo(() => {
    if (!studentPopulation || !studentPopulation.classes) {
      return {
        series: [{ name: 'Students', data: [] }],
        options: {
          xaxis: { categories: [] },
        },
      };
    }

    // Build data array from break_down and labels from class_name
    const categories = studentPopulation.classes.map((cls) => cls.class_name);
    const data = studentPopulation.classes.map((cls) => {
      const count = studentPopulation.break_down[cls.class_id];
      return parseInt(count || 0);
    });

    return {
      series: [{ name: 'Students', data }],
      options: {
        chart: {
          type: 'bar',
          height: '100%',
          toolbar: { show: true },
          zoom: { enabled: false },
        },
        plotOptions: {
          bar: {
            borderRadius: 6,
            horizontal: false,
            columnWidth: '45%',
            endingShape: 'rounded',
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories,
          labels: {
            style: { colors: '#6c757d', fontSize: '12px' },
          },
        },
        yaxis: {
          labels: {
            style: { colors: '#6c757d', fontSize: '12px' },
          },
          title: {
            text: 'Number of Students',
            style: { fontSize: '12px' },
          },
        },
        fill: {
          opacity: 1,
        },
        colors: ['#4e73df'],
        tooltip: {
          theme: 'light',
        },
      },
    };
  }, [studentPopulation]);

  return (
    <div className="main-card mb-0 card">
      <div className="card-header">
        <h5 className="menu-header-title card-title mb-0">Student Population by Class</h5>
      </div>
      <div className="card-body p-0">
        <Chart 
          options={chartData.options} 
          series={chartData.series} 
          type="bar" 
          height="155" 
          width="100%" 
        />
      </div>
    </div>
  );
};

export default StudentPopulationGraph;
